/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Link_InvalidInputs */



/**
* | output |
* | --- |
* | "Link expired or invalid" |
*
* @param {Auth_Verify_Link_InvalidInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_link_invalid = /** @type {((inputs?: Auth_Verify_Link_InvalidInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Link_InvalidInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lien expiré ou invalide")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enlace expirado o inválido")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Link expirado ou inválido")
	if (locale === "it") return /** @type {LocalizedString} */ ("Link scaduto o non valido")
	return /** @type {LocalizedString} */ ("Link expired or invalid")
});